import React from "react";
import { observer, inject } from "mobx-react";
import { applySnapshot } from "mobx-state-tree";
import * as M from "@material-ui/core";
import * as Icon from "react-feather";
import * as H from "../helpers";

import { entries } from "mobx";

const QuestionEdit = props => {
  const { $question, $validation, $survey, $locale, $user, $config } = props.store;

  let latestRowRef = React.useRef();

  React.useEffect(() => {
    if (document.activeElement.name === "addRow") {
      document.activeElement.value = "";
      var strLength = latestRowRef.value.length;
      latestRowRef && latestRowRef.focus();
      latestRowRef && latestRowRef.setSelectionRange(strLength, strLength);
    }
  }, [document.activeElement.name, latestRowRef]);

  const appConfigSelectedType = $config.field_types.find(
    type => type.value === $question.selected.type
  );

  return (
    <M.Dialog
      open={Boolean($question.selected)}
      maxWidth="sm"
      fullWidth
      onClose={() => {
        $question.detach($question.selected);
        $locale.clearSelectedList();
      }}
    >
      <M.DialogTitle>
        {`${$config.getLabelForFieldType($question.selected.type)} ${
          $question.selected._key === "new" ? "toevoegen" : "bewerken"
        } ${$user.sessionUser.isAdmin ? "(" + $question.selected._key + ")" : ""}`}
      </M.DialogTitle>
      <M.DialogContent>
        <form name="question-edit">
          {$user.sessionUser.isAdmin && (
            <>
              <M.Box my={2} py={2}>
                <M.Grid container spacing={4} mb={8}>
                  {/* PARENTKEY */}
                  <M.Grid item md={6}>
                    <M.TextField
                      fullWidth
                      label="Parentkey"
                      onChange={e => $question.selected.change("parentKey", e.target.value)}
                      value={$question.selected.parentKey || ""}
                    />
                  </M.Grid>
                  {/* ORDER */}
                  <M.Grid item md={6}>
                    <M.TextField
                      fullWidth
                      label="Order"
                      onChange={e => $question.selected.change("order", Number(e.target.value))}
                      value={$question.selected.order}
                    />
                  </M.Grid>
                </M.Grid>
              </M.Box>
              <M.Divider />
            </>
          )}

          {/* NAME */}
          <M.Box my={2} py={2}>
            <label>Vraag</label>
            {$survey.selected.languages
              .split(",")
              .map(
                (language, i) =>
                  language && (
                    <M.TextField
                      fullWidth
                      label={$locale.getLanguageLabelForKey(language, "NL")}
                      name={"name"}
                      key={language}
                      value={$locale.t($question.selected._key, language, false)}
                      onChange={e =>
                        $locale.setSelected($question.selected._key, language, e.target.value)
                      }
                    />
                  )
              )}
          </M.Box>

          <M.Divider />

          {/* TYPE */}
          <M.Box my={2} py={2}>
            {$question.selected.type !== "fieldset" && (
              <M.TextField
                fullWidth
                label={"Type vraag"}
                name="type"
                disabled={$question.selected._key !== "new" && !$survey.selected.editable}
                select
                value={$question.selected.type || "select"}
                onChange={e => $question.selected.change("type", e.target.value)}
              >
                {$config.field_types
                  .filter(
                    type =>
                      (type.roles &&
                        type.roles.some(value => $user.sessionUser.roles.indexOf(value) > -1)) ||
                      !type.roles
                  )
                  .filter(
                    type => $question.selected.type !== "fieldset" && type.value !== "fieldset"
                  )
                  .map((type, i) => (
                    <M.MenuItem key={i} value={type.value}>
                      {type.label}
                    </M.MenuItem>
                  ))}
              </M.TextField>
            )}
          </M.Box>

          {$question.selected.type === "list" && (
            <M.Box mb={2} pb={2}>
              <b>Keuzes</b>
              {$question.selected.typeOptions.map((option, i) => (
                <M.Box display="flex" mb={3} key={"option" + i}>
                  <M.Box mr={1}>
                    {$survey.selected.languages.split(",").map(
                      (language, j) =>
                        language && (
                          <M.TextField
                            fullWidth
                            key={language}
                            label={$locale.getLanguageLabelForKey(language, "NL")}
                            name={"option_" + i + "_" + language}
                            value={
                              option.locale[language] ||
                              $locale.t($question.selected._key + "_option" + i, language, false) ||
                              option.label ||
                              ""
                            }
                            inputRef={input => {
                              if (
                                j === 0 &&
                                $question.selected &&
                                i === $question.selected.typeOptions.length - 1
                              )
                                latestRowRef = input;
                            }}
                            onChange={e => {
                              applySnapshot(option, {
                                value:
                                  language === "nl_BE" ? H.slugify(e.target.value) : option.value,
                                label: "",
                                locale: {
                                  ...option.locale,
                                  [language]: e.target.value
                                }
                              });
                            }}
                          />
                        )
                    )}
                  </M.Box>
                  <M.TextField
                    disabled
                    name={"option" + i}
                    value={option.value || ""}
                    onChange={e => option.slugifyAndChange("value", e.target.value)}
                  />
                  <M.Box>
                    <M.IconButton
                      onClick={e => $question.selected.removeFromTypeOptions(option, i)}
                    >
                      <Icon.Trash />
                    </M.IconButton>
                  </M.Box>
                </M.Box>
              ))}
              <M.TextField
                placeholder="Keuze toevoegen"
                fullWidth
                name="addRow"
                onChange={e => $question.selected.addToTypeOptions(e.target.value)}
              />
              <M.FormControlLabel
                control={
                  <M.Checkbox
                    name="multipleAnswers"
                    checked={$question.selected.multipleAnswers}
                    onChange={e => {
                      $question.selected.change(e.target.name, e.target.checked ? true : false);
                    }}
                  />
                }
                label="Meerdere keuzes mogelijk"
              />
            </M.Box>
          )}

          {$question.selected.type.indexOf("scale") > -1 && (
            <M.Box mb={2} pb={2}>
              {$question.selected.type !== "scale_custom" &&
                appConfigSelectedType &&
                appConfigSelectedType.options.map(option => (
                  <div key={option.value}>
                    {option.label} ({option.value})
                  </div>
                ))}
              {$question.selected.type === "scale_custom" && (
                <>
                  {$question.selected.typeOptions.map((option, i) => (
                    <M.Box display="flex" mb={3} key={"option" + i}>
                      <M.Box mr={1}>
                        {$survey.selected.languages.split(",").map(
                          (language, j) =>
                            language && (
                              <M.TextField
                                key={language}
                                label={$locale.getLanguageLabelForKey(language, "NL")}
                                fullWidth
                                name={"option_" + i + "_" + language}
                                value={
                                  option.locale[language] ||
                                  $locale.t(
                                    $question.selected._key + "_option" + i,
                                    language,
                                    false
                                  ) ||
                                  option.label
                                }
                                inputRef={input => {
                                  if (
                                    j === 0 &&
                                    $question.selected &&
                                    i === $question.selected.typeOptions.length - 1
                                  )
                                    latestRowRef = input;
                                }}
                                onChange={e => {
                                  applySnapshot(option, {
                                    value: language === "nl_BE" ? e.target.value : option.value,
                                    label: "",
                                    locale: {
                                      ...option.locale,
                                      [language]: e.target.value
                                    }
                                  });
                                }}
                              />
                            )
                        )}
                      </M.Box>
                      <M.Box>
                        <M.IconButton
                          onClick={e => $question.selected.removeFromTypeOptions(option, i)}
                        >
                          <Icon.Trash />
                        </M.IconButton>
                      </M.Box>
                    </M.Box>
                  ))}
                  <M.TextField
                    placeholder="Schaaloptie toevoegen"
                    fullWidth
                    name="addRow"
                    onChange={e => $question.selected.addToTypeOptions(e.target.value)}
                  />
                </>
              )}
            </M.Box>
          )}

          {/* REQUIRED */}

          <M.Divider />

          <M.Box my={2} py={2}>
            <M.FormControlLabel
              control={
                <M.Checkbox
                  name="required"
                  checked={$question.selected.required}
                  onChange={e => {
                    $question.selected.change(e.target.name, e.target.checked ? true : false);
                  }}
                />
              }
              label="Verplicht"
            />
          </M.Box>

          <M.Divider />

          {/* DESCRIPTION */}
          <M.Box my={2} py={2}>
            <label>Omschrijving</label>
            {$survey.selected.languages
              .split(",")
              .map(
                (language, i) =>
                  language && (
                    <M.TextField
                      fullWidth
                      rows="5"
                      multiline
                      label={$locale.getLanguageLabelForKey(language, "NL")}
                      name={"description"}
                      key={language}
                      value={$locale.t($question.selected._key + "_description", language, false)}
                      onChange={e =>
                        $locale.setSelected(
                          $question.selected._key + "_description",
                          language,
                          e.target.value
                        )
                      }
                    />
                  )
              )}
          </M.Box>

          <M.Divider />

          {/* FEEDBACK */}
          {$user.sessionUser.isVerifiedCreator && (
            <M.Box my={2} py={2}>
              <label className="mb1">Feedback</label>

              {$survey.selected.languages
                .split(",")
                .map(
                  (language, i) =>
                    language && (
                      <M.TextField
                        fullWidth
                        rows="5"
                        multiline
                        label={$locale.getLanguageLabelForKey(language, "NL")}
                        name={"feedback"}
                        key={language}
                        value={$locale.t($question.selected._key + "_feedback", language, false)}
                        onChange={e =>
                          $locale.setSelected(
                            $question.selected._key + "_feedback",
                            language,
                            e.target.value
                          )
                        }
                      />
                    )
                )}
            </M.Box>
          )}

          <M.Divider />

          {$question.selected.type !== "fieldset" && $user.sessionUser.isVerifiedCreator && (
            <M.Box my={2} py={2}>
              <M.FormControlLabel
                control={
                  <M.Checkbox
                    name="logic"
                    checked={$question.selected.logic}
                    onChange={$question.selected.initLogic}
                  />
                }
                label="Als/Dan"
              />

              {$question.selected.logic && (
                <M.Box>
                  {entries($question.selected.logic.conditions).map((condition, i) => (
                    <React.Fragment key={"condition" + i}>
                      <M.Box display="flex" id={condition[0]}>
                        <M.TextField
                          label="Als"
                          value={condition[1].question}
                          name={"question"}
                          className="mt-2 row col-10 ml-2"
                          disabled
                        />
                        <M.TextField
                          fullWidth
                          label={"Type vraag"}
                          name={"condition"}
                          disabled={$question.selected._key !== "new" && !$survey.selected.editable}
                          select
                          value={condition[1].condition}
                          onChange={condition[1].change}
                        >
                          {[
                            {
                              value: "is",
                              label: "is gelijk aan..."
                            },
                            {
                              value: "not",
                              label: "niet gelijk aan..."
                            }
                          ].map((type, i) => (
                            <M.MenuItem key={i} value={type.value}>
                              {type.label}
                            </M.MenuItem>
                          ))}
                        </M.TextField>
                      </M.Box>
                      <M.Box display="flex">
                        <M.TextField
                          value={condition[1].answer}
                          name={"answer"}
                          label="."
                          onChange={condition[1].change}
                        />
                        {$question.selected.logic.conditions.size > 1 && (
                          <M.Box>
                            <M.IconButton
                              onClick={() =>
                                $question.selected.logic.deleteFromConditionList(condition[0])
                              }
                            >
                              <Icon.Minus />
                            </M.IconButton>
                          </M.Box>
                        )}
                      </M.Box>
                      <M.IconButton
                        onClick={() =>
                          $question.selected.logic.setToConditionList(Date.now(), {
                            question: "",
                            condition: "is",
                            answer: ""
                          })
                        }
                      >
                        <Icon.Plus />
                      </M.IconButton>
                    </React.Fragment>
                  ))}
                  <M.TextField
                    fullWidth
                    label="Actie"
                    name="action"
                    select
                    value={$question.selected.logic.action}
                    onChange={$question.selected.logic.change}
                  >
                    {$survey.selected.questions.map((question, i) => (
                      <M.MenuItem key={i} value={"hide_" + question._key}>
                        {"Verberg: " + $locale.t(question._key)}
                      </M.MenuItem>
                    ))}
                  </M.TextField>
                </M.Box>
              )}
            </M.Box>
          )}
        </form>
      </M.DialogContent>
      <M.DialogActions>
        <M.Button
          variant="outlined"
          onClick={() => {
            $question.detach($question.selected);
            $locale.clearSelectedList();
          }}
        >
          {"Annuleren"}
        </M.Button>
        <M.Button
          onClick={() => {
            const validations = $validation.validateForm("question-edit");
            if (validations.size === 0) {
              $question.selected.fsSave();
              $question.detach($question.selected);
            }
          }}
        >
          {$question.selected._key === "new" ? "Voeg toe" : "Bewaren"}
        </M.Button>
      </M.DialogActions>
    </M.Dialog>
  );
};

export default inject("store")(observer(QuestionEdit));
